const translations = {
    day: {
        ar: "اليوم",
        da: "Dag",
        de: "Tag",
        en: "Day",
        es: "Día",
        fi: "Päivä",
        fr: "Jour",
        id: "Hari",
        it: "Giorno",
        ja: "日",
        ko: "일",
        ms: "Hari",
        nl: "Dag",
        pt: "Dia",
        ru: "День",
        th: "วัน",
        tr: "Gün",
        vi: "Ngày",
        zh: "活動日",
        "zh-hans": "活动日",
    },
    moreChicks: {
        ar: "فتافيت أكثر!",
        da: "Flere kyllinger!",
        de: "Mehr Küken!",
        en: "More Chicks!",
        es: "¡Más pollitos!",
        fi: "Lisää tipuja!",
        fr: "Plus de poussins !",
        id: "Lebih Banyak Anak Ayam!",
        it: "Altri pulcini!",
        ja: "ヒヨコンだもん！",
        ko: "더 많은 병아리!",
        ms: "Lebih Banyak Anak Ayam!",
        nl: "Meer kuikentjes!",
        pt: "Mais pintinhos!",
        ru: "Больше цыплят!",
        th: "มีลูกเจี๊ยบเพิ่ม!",
        tr: "Daha Fazla Civciv!",
        vi: "Nhiều Gà con hơn!",
        zh: "更多小雞！",
        "zh-hans": "更多小鸡！",
    },
    dayComplete: {
        ar: "اكتمل اليوم {day}",
        da: "Dag {day} gennemført!",
        de: "Tag {day} abgeschlossen!",
        en: "Day {day} Complete!",
        es: "Día {day} completado",
        fi: "{day}. päivä suoritettu!",
        fr: "Jour {day} terminé !",
        id: "Hari {day} Selesai!",
        it: "{day}º giorno completato!",
        ja: "{day}日目 完了！",
        ko: "{day}일 차 완료!",
        ms: "Hari {day} Selesai!",
        nl: "Dag {day} voltooid!",
        pt: "Dia {day} concluído!",
        ru: "День {day} завершен!",
        th: "วันที่ {day} เสร็จสิ้น!",
        tr: "{day}. Gün Tamamlandı!",
        vi: "Hoàn thành Ngày {day}!",
        zh: "第{day}個活動日已完成！",
        "zh-hans": "第{day}个活动日已完成！",
    },
    claimRewards: {
        ar: "طالب بجوائزك!",
        da: "Hent dine belønninger!",
        de: "Hol dir deine Belohnungen ab!",
        en: "Claim your rewards!",
        es: "¡Reclama tus recompensas!",
        fi: "Lunasta palkintosi!",
        fr: "Récupérez vos récompenses !",
        id: "Klaim hadiahmu!",
        it: "Ritira le ricompense!",
        ja: "報酬をどうぞ！",
        ko: "보상을 획득하세요!",
        ms: "Tuntut ganjaran anda!",
        nl: "Claim je beloningen!",
        pt: "Resgate as suas recompensas!",
        ru: "Заберите награды!",
        th: "รับรางวัลของคุณ!",
        tr: "Ödüllerini al!",
        vi: "Nhận phần thưởng của bạn!",
        zh: "領取您的獎勵！",
        "zh-hans": "领取您的奖励！",
    },
    continue: {
        ar: "المتابعة",
        da: "Fortsæt",
        de: "Weiter",
        en: "Continue",
        es: "Continuar",
        fi: "Jatka",
        fr: "Continuer",
        id: "Lanjutkan",
        it: "Continua",
        ja: "続ける",
        ko: "계속하기",
        ms: "Teruskan",
        nl: "Doorgaan",
        pt: "Continuar",
        ru: "Продолжить",
        th: "เล่นต่อ",
        tr: "Devam et",
        vi: "Tiếp tục",
        zh: "繼續",
        "zh-hans": "继续",
    },
} as const;

type TranslationKey = keyof typeof translations;
type Locale = keyof (typeof translations)[TranslationKey];

export function translate(key: TranslationKey, lang: string): string {
    const entry = translations[key];
    return (entry[lang as Locale] ?? entry.en) as string;
}
